import PageHeader from "../Components/PageHeader"
import { useEffect, useState } from 'react'
import { getSubmitForm } from '../helpers/forms_helper';
import showToast from "../helpers/show_toast";
import { Card, CardBody, CardImg, Row } from 'reactstrap';
import { useNavigate } from "react-router-dom";
import Loader from "../Components/Loader";

const OurTeam = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [allData, setAllData] = useState([]);

    useEffect(() => {
        fetch_data();
    }, []);

    const fetch_data = async () => {
        setLoading(true)
        let url = "https://api.jmialumnivic.com.au/teams/getall";
        const response = await getSubmitForm(url, '')
        if (response && response.status === 1) {
            setAllData(response.data);
            setLoading(false)
        } else {
            setLoading(false)
            showToast(response.error, "error")
        }
    };
    const handle_viewDetails = (data) => {
        navigate(`/team_details/${btoa(data._id)}`, { state: data })
    }
    return (
        <>
            <section className='history_of_osa'>
                <div className="about_osa_layer">
                    <PageHeader heading="Our Team" />
                    <div className="about_main_container">
                        <div className="container">
                            <Row className='data_row_here'>
                                {loading ?
                                    <Loader />
                                    : allData && allData.length > 0 ?
                                        allData.map((data, idx) => {
                                            return (
                                                <>
                                                    <div className="col-lg-4 col-md-6 col-sm-6 col-12 " key={idx}>
                                                        <Card className="ourTeam_card" onClick={() => handle_viewDetails(data)} style={{ cursor: 'pointer' }}>
                                                            <CardImg src={data.image_url ? data.image_url : '/noimg.jpg'} style={{ height: "350px" }} alt="" />
                                                            <CardBody className='text-center px-1  pb-0'>
                                                                <div className="newjoiner_details">
                                                                    <h6 className="mb-0 fw-bold">{data.name}</h6>
                                                                    <p className='text-center text-dark mb-4'>{data.designation}</p>
                                                                </div>
                                                            </CardBody>
                                                        </Card>
                                                    </div>
                                                </>
                                            )
                                        })
                                        : ''}
                            </Row>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default OurTeam
